import React from 'react';
import { View } from 'react-native';
import {colors} from '@mmt/legacy-commons/Styles/globalStyles';
import Spinner from '@Frontend_Ui_Lib_App/Spinner';

const Loader = () => (
  <View style={{
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  }}
  >
    <Spinner size={30} color={colors.azure} />
  </View>
);

export default Loader;
